/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mock_Agent_StatusInputs */

const en_mk_mock_agent_status = /** @type {(inputs: Mk_Mock_Agent_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active`)
};

const id_mk_mock_agent_status = /** @type {(inputs: Mk_Mock_Agent_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktif`)
};

/**
* | output |
* | --- |
* | "Active" |
*
* @param {Mk_Mock_Agent_StatusInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mock_agent_status = /** @type {((inputs?: Mk_Mock_Agent_StatusInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mock_Agent_StatusInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mock_agent_status(inputs)
	return en_mk_mock_agent_status(inputs)
});